<template>
  <step @nextStep="$emit('nextStep', 5)"></step>
</template>
<script>
import step from '@/views/Education2/Lesson1/components/step3'

export default {
  name: 'step4',
  components: {
    step,
  },
}
</script>
